import frustumCull from '../frustumCull'
import hsv_rgb from '../hsv_rgb'
import noise3D from '../noise3D'

export default `${noise3D + hsv_rgb}
uniform vec4 uRectData;
uniform vec3 uBgColor;
uniform vec4 uProgress;

varying vec2 vUv;
varying vec3 vNormal;
varying vec3 vNormal2;
varying vec3 vPosition;
varying vec2 vScreenPos;
varying vec2 vCenterPos;

void main(){
  vec3 pos = floor(vPosition * 5.0 / 1.2);
  vec3 noiseFactor = floor((vNormal * 1.4));
  float n = noise(pos + noiseFactor) * 0.5 + 0.5;

  float light = dot(normalize(vNormal2), normalize(vec3(1.0, 4.0, 1.0))) * 0.5 + 0.5;

  vec2 centerDistance = vScreenPos - vCenterPos;

  float l = length(centerDistance);
  l = smoothstep(0.08, 0.0, l);

  n = smoothstep(0.3, 1.0, n);

  vec3 hsv = vec3(0.9, 0.4, 1.0);
  hsv.r -= l * 0.4;
  vec3 centerColor = hsv2rgb(hsv);
  centerColor = mix(centerColor, vec3(1.0, 0.9, 0.5), smoothstep(0.5, 1.0, l) * 0.4);

  vec3 color = mix(centerColor * 0.1 + 0.9, centerColor, n);
  color = mix(color * 0.8, color, light);

  ${frustumCull}

  color = mix(uBgColor, color, uProgress.x );

  gl_FragColor = vec4(color, 1.0);


}
`
